import React, { useEffect, useState } from "react";
import { Box, Typography, Avatar, CircularProgress } from "@mui/material";
import { useFileQuery } from "@query/fileQuery";

const ImageAvatarView = ({
  fileUuid,
  className = "",
  sx = {},
  avatarSx = {},
  variant = "circular",
  renderCustom
}) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileQuery = useFileQuery(fileUuid);

  useEffect(() => {
    if (fileQuery.isSuccess && fileQuery.data?.data instanceof Blob) {
      const url = URL.createObjectURL(fileQuery.data.data);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [fileQuery.data, fileQuery.isSuccess]);

  if (!fileUuid) return null;

  return (
    <Box className={className} sx={{ textAlign: "center", ...sx }}>
      {fileQuery.isLoading && <CircularProgress />}
      {fileQuery.isError && (
        <Typography color="error">Failed to load file.</Typography>
      )}
      {fileQuery.isSuccess && previewUrl && (
        renderCustom ? (
          renderCustom({ fileUuid, fileBlob: fileQuery.data?.data, fileUrl: previewUrl })
        ) : (
          <>
              <Avatar
                src={previewUrl}
                variant={variant}
                alt="File preview"
                sx={{ width: 200, height: 200, mx: "auto", ...avatarSx}}
              />
    
          </>
        )
      )}
    </Box>
  );
};

export default ImageAvatarView;
